var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('NewAberrationRuhContainer',{attrs:{"icon":"mdi-alert-octagram-outline","aberrationCategory":"4","categoryName":"HMS Observasjon"},on:{"save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }